import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'hbo-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss']
})
export class DashboardCardComponent {
  @Input() ctaText: string = '';
  @Input() headerColor: string | null = null;
  @Input() outlineColor: string | null = null;
  @Input() headerLogoImage: string | null = null;
  @Input() bodyImage: string | null = null;
  @Input() secondCtaText: string = '';

  @Output() actionClick = new EventEmitter<void>();
  @Output() secondActionClick = new EventEmitter<void>();

  onCtaClick(): void {
    this.actionClick.emit();
  }

  onSecondCtaClick(): void {
    this.secondActionClick.emit();
  }
}
